import { useMemo } from 'react';
import { appendClassName, makeBEM } from '../../../utils';
export var useBadgeClassName = function useBadgeClassName(classPrefix, className) {
  return useMemo(function () {
    return {
      Root: appendClassName(makeBEM(classPrefix, 'Root'), className)
    };
  }, [classPrefix, className]);
};